import {FAILURE, PENDING, SUCCESS} from '../../constants'
import {getApprovalManagerGroupIds as getApprovalManagerGroupIdsApi} from '../../../services/reservations'

export async function getApprovalManagerGroup(dispatch) {
  try {
    dispatch({type: PENDING})
    let response = await getApprovalManagerGroupIdsApi()
    dispatch({type: SUCCESS, payload: response})
    return response
  } catch (e) {
    console.log(`Get Reservation Configuration Failed`)
    dispatch({type: FAILURE, payload: e})
    return Promise.reject(e)
  }
}
